module.exports = __webpack_public_path__ + "static/img/banner.c33bf24.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/contact/banner.jpg
// module id = +QFB
// module chunks = 1